import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Divider, Typography } from 'antd';

import { PageProps } from '@/types/PageProps';
import { useWindowSize } from '@/hooks';
import { useState } from 'react';
import TabsCustom from '@/components/_common/TabsCustom';
import IntegrationMichelinSettings from '@/components/Companies/Settings/CompanyIntegrations/Michelin';

const { Title } = Typography;

export const initialTabErrors = {
  recommendation: false,
  category: false,
  configuration: false,
};

export default function CompanyIntegrationsPage({ route }: PageProps) {
  const intl = useIntl();
  const { width } = useWindowSize();

  const [menuKeyActive, setMenuKeyActive] = useState<string>('michelin');

  return (
    <>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div style={{ marginLeft: '24px' }}>
        <Title level={width < 576 ? 5 : 4}>Integrações</Title>
      </div>

      <Divider />

      <TabsCustom
        key={menuKeyActive}
        activeKey={menuKeyActive}
        onChange={setMenuKeyActive}
      >
        <TabsCustom.Item label="Michelin" key="michelin">
          <IntegrationMichelinSettings />
        </TabsCustom.Item>
      </TabsCustom>
    </>
  );
}
